import React from "react";

const FeatureContext = React.createContext();

export default FeatureContext;
